export default __webpack_public_path__ + "5515c85f31bdd78d8ca69df766abdffb.png";